import * as style from './style'
import Avatar from '@/components/V2/Avatar'
import { ArticleCard as ArticleCardType } from '@/shared/api-generated-types'
import { getConfig } from '@/lib/config'
import { AIElementNames, eventsTracker } from '@/lib/eventsTracker'

export interface Props extends Omit<ArticleCardType, '__typename'> {}

const ArticleCard = (props: Props): JSX.Element => {
  const config = getConfig()
  const detailsPageLink = `${config.publicRuntimeConfig.website.url}/articles/${props.slug}/${props.id}`
  return (
    <div className="bg-white rounded-2xl overflow-hidden shadow-lg">
      <a
        href={detailsPageLink}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => eventsTracker.handleOnClickAndTrackEvent(AIElementNames.BUTTON_ARTICLE_CARD)}
      >
        <div className={`${style.imageContainer}`}>
          {
            <img
              alt={'thumbnail'}
              src={props.imageUrl ?? '/images/image-placeholder-large.png'}
              className={style.image}
              loading="lazy"
              decoding="async"
            />
          }
        </div>
        {props.guideAvatarUrl && (
          <Avatar className="ml-3 mt-[-48px] border-white z-2" size="xsmd" src={props.guideAvatarUrl} outlined />
        )}
        <div className="p-4">
          <h3 className="font-bold text-base text-[#2D2D32] mb-1">{props.title}</h3>
          <p className="text-sm text-[#757582] mb-4">{props.guideName}</p>
          {props.readTimeInSeconds && (
            <div className="absolute bottom-3 flex items-center text-[#2D2D32]">
              <span className="font-bold">Read:</span>
              <span className="text-sm">{Math.ceil(props.readTimeInSeconds / 60)} min</span>
            </div>
          )}
        </div>
      </a>
    </div>
  )
}

export default ArticleCard
